import { Injectable } from "@angular/core";
import { ICampaignCheck } from "@edp-components/campaign-modal/campaign-modal.model";
import { ApiService } from "@edp-services/api.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class CampaignService {

    constructor(private apiService: ApiService) { }

    public checkCampaign(contractId: string): Observable<ICampaignCheck | Error> {
        return this.apiService.callServicePostToCollection("campaign.checkCampaignAccess", {
            ContractId: contractId
        });
    }

    public getOpenAreaCampaign() {
        return this.apiService.callServicePostToCollectionCatalog("payment.campaign", {});
    }
}
